import React from 'react';
import { ModuleHeaderFragmentLayout } from 'app/fragments/module-header-fragment/layout';
import { BreadcrumbLinkModel } from 'app/components/Breadcrumb/data';
import { SwitchButtonProps } from 'app/components/SwitchButton';

export interface ModuleHeaderFragmentProps {
  showBreadCrumbs?: boolean;
  switch?: boolean;
  showSwitch?: boolean;
  showFilter?: boolean;
  showAggregate?: boolean;
  openSearch?: boolean;
  loadGeoData?: boolean;
  geoData?: any;
  switchOneLabel?: string;
  breadcrumbs?: BreadcrumbLinkModel[];
  switchProps?: SwitchButtonProps;
  explorePage?: boolean;
}

export const ModuleHeaderFragment = (props: ModuleHeaderFragmentProps) => {
  return <ModuleHeaderFragmentLayout {...props} />;
};
